/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IntCalculationDataTransferObject } from './IntCalculationDataTransferObject';
import {
    IntCalculationDataTransferObjectFromJSON,
    IntCalculationDataTransferObjectFromJSONTyped,
    IntCalculationDataTransferObjectToJSON,
    IntCalculationDataTransferObjectToJSONTyped,
} from './IntCalculationDataTransferObject';
import type { FloatCalculationDataTransferObject } from './FloatCalculationDataTransferObject';
import {
    FloatCalculationDataTransferObjectFromJSON,
    FloatCalculationDataTransferObjectFromJSONTyped,
    FloatCalculationDataTransferObjectToJSON,
    FloatCalculationDataTransferObjectToJSONTyped,
} from './FloatCalculationDataTransferObject';
import type { MoneyCalculationDataTransferObject } from './MoneyCalculationDataTransferObject';
import {
    MoneyCalculationDataTransferObjectFromJSON,
    MoneyCalculationDataTransferObjectFromJSONTyped,
    MoneyCalculationDataTransferObjectToJSON,
    MoneyCalculationDataTransferObjectToJSONTyped,
} from './MoneyCalculationDataTransferObject';
import type { PrecalculationSnapshotReadMetadata } from './PrecalculationSnapshotReadMetadata';
import {
    PrecalculationSnapshotReadMetadataFromJSON,
    PrecalculationSnapshotReadMetadataFromJSONTyped,
    PrecalculationSnapshotReadMetadataToJSON,
    PrecalculationSnapshotReadMetadataToJSONTyped,
} from './PrecalculationSnapshotReadMetadata';
import type { NullableMoneyCalculationDataTransferObject } from './NullableMoneyCalculationDataTransferObject';
import {
    NullableMoneyCalculationDataTransferObjectFromJSON,
    NullableMoneyCalculationDataTransferObjectFromJSONTyped,
    NullableMoneyCalculationDataTransferObjectToJSON,
    NullableMoneyCalculationDataTransferObjectToJSONTyped,
} from './NullableMoneyCalculationDataTransferObject';

/**
 * 
 * @export
 * @interface BasicShopStatistics
 */
export interface BasicShopStatistics {
    /**
     * 
     * @type {string}
     * @memberof BasicShopStatistics
     */
    currentSince?: string;
    /**
     * 
     * @type {string}
     * @memberof BasicShopStatistics
     */
    currentUntil?: string;
    /**
     * 
     * @type {string}
     * @memberof BasicShopStatistics
     */
    previousSince?: string;
    /**
     * 
     * @type {string}
     * @memberof BasicShopStatistics
     */
    previousUntil?: string;
    /**
     * 
     * @type {MoneyCalculationDataTransferObject}
     * @memberof BasicShopStatistics
     */
    turnoverNet?: MoneyCalculationDataTransferObject;
    /**
     * 
     * @type {MoneyCalculationDataTransferObject}
     * @memberof BasicShopStatistics
     */
    turnoverGross?: MoneyCalculationDataTransferObject;
    /**
     * 
     * @type {MoneyCalculationDataTransferObject}
     * @memberof BasicShopStatistics
     */
    spendGoodsNet?: MoneyCalculationDataTransferObject;
    /**
     * 
     * @type {MoneyCalculationDataTransferObject}
     * @memberof BasicShopStatistics
     */
    spendGoodsGross?: MoneyCalculationDataTransferObject;
    /**
     * 
     * @type {MoneyCalculationDataTransferObject}
     * @memberof BasicShopStatistics
     */
    spendMarketing?: MoneyCalculationDataTransferObject;
    /**
     * 
     * @type {number}
     * @memberof BasicShopStatistics
     */
    purchaseCostUnknownNetCurrent?: number;
    /**
     * 
     * @type {number}
     * @memberof BasicShopStatistics
     */
    purchaseCostUnknownGrossCurrent?: number;
    /**
     * 
     * @type {number}
     * @memberof BasicShopStatistics
     */
    purchaseCostEstimatedNetCurrent?: number;
    /**
     * 
     * @type {number}
     * @memberof BasicShopStatistics
     */
    purchaseCostEstimatedGrossCurrent?: number;
    /**
     * 
     * @type {boolean}
     * @memberof BasicShopStatistics
     */
    purchaseCostQualityAvailableCurrent?: boolean;
    /**
     * 
     * @type {number}
     * @memberof BasicShopStatistics
     */
    purchaseCostUnknownNetPrevious?: number;
    /**
     * 
     * @type {number}
     * @memberof BasicShopStatistics
     */
    purchaseCostUnknownGrossPrevious?: number;
    /**
     * 
     * @type {number}
     * @memberof BasicShopStatistics
     */
    purchaseCostEstimatedNetPrevious?: number;
    /**
     * 
     * @type {number}
     * @memberof BasicShopStatistics
     */
    purchaseCostEstimatedGrossPrevious?: number;
    /**
     * 
     * @type {boolean}
     * @memberof BasicShopStatistics
     */
    purchaseCostQualityAvailablePrevious?: boolean;
    /**
     * 
     * @type {PrecalculationSnapshotReadMetadata}
     * @memberof BasicShopStatistics
     */
    currentSnapshot?: PrecalculationSnapshotReadMetadata | null;
    /**
     * 
     * @type {PrecalculationSnapshotReadMetadata}
     * @memberof BasicShopStatistics
     */
    previousSnapshot?: PrecalculationSnapshotReadMetadata | null;
    /**
     * 
     * @type {IntCalculationDataTransferObject}
     * @memberof BasicShopStatistics
     */
    orderAmountNet?: IntCalculationDataTransferObject;
    /**
     * 
     * @type {IntCalculationDataTransferObject}
     * @memberof BasicShopStatistics
     */
    orderAmountGross?: IntCalculationDataTransferObject;
    /**
     * 
     * @type {FloatCalculationDataTransferObject}
     * @memberof BasicShopStatistics
     */
    pnoNet?: FloatCalculationDataTransferObject;
    /**
     * 
     * @type {FloatCalculationDataTransferObject}
     * @memberof BasicShopStatistics
     */
    pnoGross?: FloatCalculationDataTransferObject;
    /**
     * 
     * @type {NullableMoneyCalculationDataTransferObject}
     * @memberof BasicShopStatistics
     */
    averageOrderValueNet?: NullableMoneyCalculationDataTransferObject;
    /**
     * 
     * @type {NullableMoneyCalculationDataTransferObject}
     * @memberof BasicShopStatistics
     */
    averageOrderValueGross?: NullableMoneyCalculationDataTransferObject;
    /**
     * 
     * @type {MoneyCalculationDataTransferObject}
     * @memberof BasicShopStatistics
     */
    gainNet?: MoneyCalculationDataTransferObject | null;
    /**
     * 
     * @type {MoneyCalculationDataTransferObject}
     * @memberof BasicShopStatistics
     */
    gainGross?: MoneyCalculationDataTransferObject | null;
    /**
     * 
     * @type {boolean}
     * @memberof BasicShopStatistics
     */
    purchaseCostCompleteNetCurrent?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BasicShopStatistics
     */
    purchaseCostCompleteGrossCurrent?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BasicShopStatistics
     */
    purchaseCostCompleteNetPrevious?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BasicShopStatistics
     */
    purchaseCostCompleteGrossPrevious?: boolean;
}

/**
 * Check if a given object implements the BasicShopStatistics interface.
 */
export function instanceOfBasicShopStatistics(value: object): value is BasicShopStatistics {
    return true;
}

export function BasicShopStatisticsFromJSON(json: any): BasicShopStatistics {
    return BasicShopStatisticsFromJSONTyped(json, false);
}

export function BasicShopStatisticsFromJSONTyped(json: any, ignoreDiscriminator: boolean): BasicShopStatistics {
    if (json == null) {
        return json;
    }
    return {
        
        'currentSince': json['currentSince'] == null ? undefined : json['currentSince'],
        'currentUntil': json['currentUntil'] == null ? undefined : json['currentUntil'],
        'previousSince': json['previousSince'] == null ? undefined : json['previousSince'],
        'previousUntil': json['previousUntil'] == null ? undefined : json['previousUntil'],
        'turnoverNet': json['turnoverNet'] == null ? undefined : MoneyCalculationDataTransferObjectFromJSON(json['turnoverNet']),
        'turnoverGross': json['turnoverGross'] == null ? undefined : MoneyCalculationDataTransferObjectFromJSON(json['turnoverGross']),
        'spendGoodsNet': json['spendGoodsNet'] == null ? undefined : MoneyCalculationDataTransferObjectFromJSON(json['spendGoodsNet']),
        'spendGoodsGross': json['spendGoodsGross'] == null ? undefined : MoneyCalculationDataTransferObjectFromJSON(json['spendGoodsGross']),
        'spendMarketing': json['spendMarketing'] == null ? undefined : MoneyCalculationDataTransferObjectFromJSON(json['spendMarketing']),
        'purchaseCostUnknownNetCurrent': json['purchaseCostUnknownNetCurrent'] == null ? undefined : json['purchaseCostUnknownNetCurrent'],
        'purchaseCostUnknownGrossCurrent': json['purchaseCostUnknownGrossCurrent'] == null ? undefined : json['purchaseCostUnknownGrossCurrent'],
        'purchaseCostEstimatedNetCurrent': json['purchaseCostEstimatedNetCurrent'] == null ? undefined : json['purchaseCostEstimatedNetCurrent'],
        'purchaseCostEstimatedGrossCurrent': json['purchaseCostEstimatedGrossCurrent'] == null ? undefined : json['purchaseCostEstimatedGrossCurrent'],
        'purchaseCostQualityAvailableCurrent': json['purchaseCostQualityAvailableCurrent'] == null ? undefined : json['purchaseCostQualityAvailableCurrent'],
        'purchaseCostUnknownNetPrevious': json['purchaseCostUnknownNetPrevious'] == null ? undefined : json['purchaseCostUnknownNetPrevious'],
        'purchaseCostUnknownGrossPrevious': json['purchaseCostUnknownGrossPrevious'] == null ? undefined : json['purchaseCostUnknownGrossPrevious'],
        'purchaseCostEstimatedNetPrevious': json['purchaseCostEstimatedNetPrevious'] == null ? undefined : json['purchaseCostEstimatedNetPrevious'],
        'purchaseCostEstimatedGrossPrevious': json['purchaseCostEstimatedGrossPrevious'] == null ? undefined : json['purchaseCostEstimatedGrossPrevious'],
        'purchaseCostQualityAvailablePrevious': json['purchaseCostQualityAvailablePrevious'] == null ? undefined : json['purchaseCostQualityAvailablePrevious'],
        'currentSnapshot': json['currentSnapshot'] === undefined ? undefined : json['currentSnapshot'] === null ? null : PrecalculationSnapshotReadMetadataFromJSON(json['currentSnapshot']),
        'previousSnapshot': json['previousSnapshot'] === undefined ? undefined : json['previousSnapshot'] === null ? null : PrecalculationSnapshotReadMetadataFromJSON(json['previousSnapshot']),
        'orderAmountNet': json['orderAmountNet'] == null ? undefined : IntCalculationDataTransferObjectFromJSON(json['orderAmountNet']),
        'orderAmountGross': json['orderAmountGross'] == null ? undefined : IntCalculationDataTransferObjectFromJSON(json['orderAmountGross']),
        'pnoNet': json['pnoNet'] == null ? undefined : FloatCalculationDataTransferObjectFromJSON(json['pnoNet']),
        'pnoGross': json['pnoGross'] == null ? undefined : FloatCalculationDataTransferObjectFromJSON(json['pnoGross']),
        'averageOrderValueNet': json['averageOrderValueNet'] == null ? undefined : NullableMoneyCalculationDataTransferObjectFromJSON(json['averageOrderValueNet']),
        'averageOrderValueGross': json['averageOrderValueGross'] == null ? undefined : NullableMoneyCalculationDataTransferObjectFromJSON(json['averageOrderValueGross']),
        'gainNet': json['gainNet'] === undefined ? undefined : json['gainNet'] === null ? null : MoneyCalculationDataTransferObjectFromJSON(json['gainNet']),
        'gainGross': json['gainGross'] === undefined ? undefined : json['gainGross'] === null ? null : MoneyCalculationDataTransferObjectFromJSON(json['gainGross']),
        'purchaseCostCompleteNetCurrent': json['purchaseCostCompleteNetCurrent'] == null ? undefined : json['purchaseCostCompleteNetCurrent'],
        'purchaseCostCompleteGrossCurrent': json['purchaseCostCompleteGrossCurrent'] == null ? undefined : json['purchaseCostCompleteGrossCurrent'],
        'purchaseCostCompleteNetPrevious': json['purchaseCostCompleteNetPrevious'] == null ? undefined : json['purchaseCostCompleteNetPrevious'],
        'purchaseCostCompleteGrossPrevious': json['purchaseCostCompleteGrossPrevious'] == null ? undefined : json['purchaseCostCompleteGrossPrevious'],
    };
}

export function BasicShopStatisticsToJSON(json: any): BasicShopStatistics {
    return BasicShopStatisticsToJSONTyped(json, false);
}

export function BasicShopStatisticsToJSONTyped(value?: BasicShopStatistics | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'currentSince': value['currentSince'],
        'currentUntil': value['currentUntil'],
        'previousSince': value['previousSince'],
        'previousUntil': value['previousUntil'],
        'turnoverNet': MoneyCalculationDataTransferObjectToJSON(value['turnoverNet']),
        'turnoverGross': MoneyCalculationDataTransferObjectToJSON(value['turnoverGross']),
        'spendGoodsNet': MoneyCalculationDataTransferObjectToJSON(value['spendGoodsNet']),
        'spendGoodsGross': MoneyCalculationDataTransferObjectToJSON(value['spendGoodsGross']),
        'spendMarketing': MoneyCalculationDataTransferObjectToJSON(value['spendMarketing']),
        'purchaseCostUnknownNetCurrent': value['purchaseCostUnknownNetCurrent'],
        'purchaseCostUnknownGrossCurrent': value['purchaseCostUnknownGrossCurrent'],
        'purchaseCostEstimatedNetCurrent': value['purchaseCostEstimatedNetCurrent'],
        'purchaseCostEstimatedGrossCurrent': value['purchaseCostEstimatedGrossCurrent'],
        'purchaseCostQualityAvailableCurrent': value['purchaseCostQualityAvailableCurrent'],
        'purchaseCostUnknownNetPrevious': value['purchaseCostUnknownNetPrevious'],
        'purchaseCostUnknownGrossPrevious': value['purchaseCostUnknownGrossPrevious'],
        'purchaseCostEstimatedNetPrevious': value['purchaseCostEstimatedNetPrevious'],
        'purchaseCostEstimatedGrossPrevious': value['purchaseCostEstimatedGrossPrevious'],
        'purchaseCostQualityAvailablePrevious': value['purchaseCostQualityAvailablePrevious'],
        'currentSnapshot': PrecalculationSnapshotReadMetadataToJSON(value['currentSnapshot']),
        'previousSnapshot': PrecalculationSnapshotReadMetadataToJSON(value['previousSnapshot']),
        'orderAmountNet': IntCalculationDataTransferObjectToJSON(value['orderAmountNet']),
        'orderAmountGross': IntCalculationDataTransferObjectToJSON(value['orderAmountGross']),
        'pnoNet': FloatCalculationDataTransferObjectToJSON(value['pnoNet']),
        'pnoGross': FloatCalculationDataTransferObjectToJSON(value['pnoGross']),
        'averageOrderValueNet': NullableMoneyCalculationDataTransferObjectToJSON(value['averageOrderValueNet']),
        'averageOrderValueGross': NullableMoneyCalculationDataTransferObjectToJSON(value['averageOrderValueGross']),
        'gainNet': MoneyCalculationDataTransferObjectToJSON(value['gainNet']),
        'gainGross': MoneyCalculationDataTransferObjectToJSON(value['gainGross']),
        'purchaseCostCompleteNetCurrent': value['purchaseCostCompleteNetCurrent'],
        'purchaseCostCompleteGrossCurrent': value['purchaseCostCompleteGrossCurrent'],
        'purchaseCostCompleteNetPrevious': value['purchaseCostCompleteNetPrevious'],
        'purchaseCostCompleteGrossPrevious': value['purchaseCostCompleteGrossPrevious'],
    };
}

